import { Dispatch } from "redux";
import {
    setFraudReportSearchResults,
    setFraudReportSearchResultsLoading
} from "@redux/actions/fraud-report-actions";
import { getAssertionFraudRequest } from "@requests/reports/get-assertion-fraud";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { SERVER_DATE_TIME_FORMAT } from "@constants/date-formats";
import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";
import format from "date-fns/format";
import { formatAssertionFraudResults } from "@formatters/assertion-fraud-results/assertion-fraud-result-formatter";
import { Assertion, RiskLevel } from "@idw-types/data/reference-data/generic";
import { generateQueryParameters } from "@utils/query-parameter-util";

export const getFraudReportReduxRequest = (dispatch: Dispatch) => async (
    companyId: string,
    rpServiceIds: Array<string>,
    relyingPartyIds: Array<string>,
    assertionIds: Array<string>,
    riskLevelIds: Array<string>,
    startDate: Date,
    endDate: Date,
    assertions: Array<Assertion>,
    riskLevels: Array<RiskLevel>
) => {
    dispatch(setFraudReportSearchResultsLoading(true));

    const queryParameters = generateQueryParameters({
        rpAXNServiceIDs: rpServiceIds,
        companyIDs: companyId,
        relyingPartyIDs: relyingPartyIds,
        assertionIDs: assertionIds,
        riskLevelIDs: riskLevelIds,
        startDate: format(startOfDay(startDate), SERVER_DATE_TIME_FORMAT),
        endDate: format(endOfDay(endDate), SERVER_DATE_TIME_FORMAT),
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        dateFormat: SERVER_DATE_TIME_FORMAT
    })

    const { data, error } = await getAssertionFraudRequest(queryParameters);
    if (data) {
        const formattedAssertionFraudResults = formatAssertionFraudResults(data, assertions, riskLevels);
        dispatch(setFraudReportSearchResults(formattedAssertionFraudResults));
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getAssertionFraud.error.title,
                resources.requests.getAssertionFraud.error.message
            );
        }
        dispatch(setFraudReportSearchResultsLoading(false));
    }
};